<article>
  <section>
    <app-cart #cartContainer></app-cart>
    <footer>
      <button (click)="onAddMore()">Sumar algo más</button>
      <button (click)="onFinish()">Terminar compra</button>
    </footer>
  </section>
</article>

<!-- Modal de timeout del pago -->
<div *ngIf="showTimeoutModal" class="modal-overlay" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Tiempo de espera agotado</h2>
      <button class="close-button" (click)="closeModal()">×</button>
    </div>
    <div class="modal-body">
      <div class="warning-icon">
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="#FF9800"/>
          <path d="M12 8v4M12 16h.01" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <p>El tiempo de espera para completar el pago ha expirado.</p>
      <p>Por favor, intenta realizar el pago nuevamente.</p>
    </div>
    <div class="modal-footer">
      <button (click)="closeModal()">Entendido</button>
    </div>
  </div>
</div>

<!-- Modal de pago rechazado o fallido -->
<div *ngIf="showPaymentFailedModal" class="modal-overlay" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Pago no realizado</h2>
      <button class="close-button" (click)="closeModal()">×</button>
    </div>
    <div class="modal-body">
      <div class="warning-icon">
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="#F44336"/>
          <path d="M15 9L9 15M9 9l6 6" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <p>El pago no pudo realizarse o fue rechazado.</p>
      <p>Revisa los datos del medio de pago o intenta nuevamente.</p>
    </div>
    <div class="modal-footer">
      <button (click)="closeModal()">Entendido</button>
    </div>
  </div>
</div>
